import { CustomButton } from 'components/ui'
import Modal from 'components/ui/Modal/Modal'
import {
  useUpdateSingleArticulo,
  useDeleteArticulo,
  useArticuloDependencies,
} from 'lib/react-query/queriesArticulos'
import React from 'react'
import { Tooltip } from 'react-tooltip'
import Loader from 'components/Loader/Loader'
import ModalWithStates from './FormNewArticulo/ModalWithStates'

const ModalDeleteArticuloAdmin = ({ handleOnClose, articulo }) => {
  const { mutateAsync: updateArticulo } = useUpdateSingleArticulo()
  const { mutateAsync: deleteArticulo } = useDeleteArticulo()
  const {
    data: dependencies,
    isLoading,
    isError,
  } = useArticuloDependencies(articulo._id)

  const handleOnClick = () => {
    updateArticulo({ id: articulo._id, active: false })
    handleOnClose()
  }

  const handleOnDelete = async () => {
    try {
      await deleteArticulo(articulo._id)
      handleOnClose()
    } catch (error) {
      console.error('Error al eliminar artículo:', error)
    }
  }

  const { hasBimlink, hasBoq, bimlinkCodes } = dependencies || {}
  const hasDependencies = hasBimlink || hasBoq

  return (
    <ModalWithStates
      isLoading={isLoading}
      isError={isError}
      dependencies={dependencies}
      onClose={handleOnClose}
    >
      <div className="modal-link-bimlink-to-tipo-container--width">
        <h2>{`Eliminar ${articulo.name}`}</h2>

        {!hasDependencies && (
          <p className="modal-link-bimlink-question">
            ¿Estás seguro de que desea eliminar este artículo? Una vez
            eliminado, no podrás recuperarlo.
          </p>
        )}

        {hasBimlink && (
          <div className="modal-link-bimlink-box">
            {hasBoq && (
              <p className="modal-link-bimlink-question">
                No puedes eliminar el artículo si pertenece a un BOQ.
              </p>
            )}
            <p className="modal-link-bimlink-question">
              No puedes eliminar el artículo si pertenece a algún BimLink:
            </p>
            <ul className="modal-link-bimlink-list">
              {bimlinkCodes?.slice(0, 5).map(code => (
                <li key={code}>{code}</li>
              ))}
              {bimlinkCodes?.length > 5 && <li>...</li>}
            </ul>
          </div>
        )}

        {hasDependencies && (
          <p>
            Puedes deshabilitar el artículo para que no aparezca al enlazar en
            ninguna BimLink.
          </p>
        )}

        <div className="buttons-container-edit-form buttons-container-delete-articulo">
          <CustomButton
            type="secondary"
            onClick={handleOnClose}
            className="button-delete-articulo"
          >
            Cancelar
          </CustomButton>
          {hasDependencies && (
            <CustomButton
              type="submit"
              className="button-delete-articulo"
              onClick={handleOnClick}
            >
              Deshabilitar
            </CustomButton>
          )}
          <CustomButton
            type="submit"
            className="button-delete-articulo button-tooltip-delete"
            onClick={handleOnDelete}
            disabled={hasDependencies}
          >
            Eliminar
          </CustomButton>
          <Tooltip
            anchorSelect=".button-tooltip-delete"
            style={{
              fontSize: '10px',
              display: hasDependencies ? 'block' : 'none',
            }}
          >
            No se puede eliminar: el artículo está vinculado a una BimLink o un
            BOQ.
          </Tooltip>
        </div>
      </div>
    </ModalWithStates>
  )
}

export default ModalDeleteArticuloAdmin
